import { t } from '../../i18n/translations';

/**
 * Localized achievement name or description. The `achievements` table holds English;
 * the i18n module `achievementContent` carries all shipped languages, keyed by
 * achievement_key. Falls back to the stored text for an unknown key.
 */
export const achievementText = (
  achievementKey: string | undefined,
  field: 'name' | 'description',
  fallback: string,
  language: string,
): string => {
  if (!achievementKey) return fallback;
  const i18nKey = `achievementContent.${achievementKey}_${field}`;
  const value = t(i18nKey, language);
  return value === i18nKey ? fallback : value;
};
